import Http from '../../../helpers/Http'
import { toast } from 'react-toastify'

export const fetchCurrentBuyerRequest = async (params) => {
    try {
        const { data } = await Http.GET(
            'fetchCurrentBuyerRequest',
            params || ''
        )
        return data
    } catch (error) {
        if (error?.response?.data?.message) {
            toast.error(error.response.data.message)
        } else {
            toast.error('Something went wrong! Please try again.')
        }
        throw error
    }
}

export const fetchBrandMembers = async (brandId) => {
    try {
        const { data } = await Http.GET_WITH_ID_PARAM(
            'brandWiseUsers',
            '',
            `${brandId}/members`
        )
        return data
    } catch (error) {
        if (error?.response?.data?.message) {
            toast.error(error.response.data.message)
        } else {
            toast.error('Something went wrong! Please try again.')
        }
        throw error
    }
}

export const fetchOverviewOrderValueByMonth = async (brandId, params = {}) => {
    try {
        const { data } = await Http.GET_WITH_ID_PARAM(
            'buyerDashboard',
            params,
            `${brandId}/order-value-by-month`
        )
        return data
    } catch (error) {
        if (error?.response?.data?.message) {
            toast.error(error.response.data.message)
        } else {
            toast.error('Something went wrong! Please try again.')
        }
        throw error
    }
}

export const fetchOverviewMonthlyPlacements = async (brandId, params = {}) => {
    try {
        const { data } = await Http.GET_WITH_ID_PARAM(
            'buyerDashboard',
            params,
            `${brandId}/monthly-placements`
        )
        return data
    } catch (error) {
        if (error?.response?.data?.message) {
            toast.error(error.response.data.message)
        } else {
            toast.error('Something went wrong! Please try again.')
        }
        throw error
    }
}

export const fetchOverviewSourcingTrends = async (brandId, params = {}) => {
    try {
        const { data } = await Http.GET_WITH_ID_PARAM(
            'buyerDashboard',
            params,
            `${brandId}/sourcing-trends`
        )
        return data
    } catch (error) {
        if (error?.response?.data?.message) {
            toast.error(error.response.data.message)
        } else {
            toast.error('Something went wrong! Please try again.')
        }
        throw error
    }
}

export const fetchOverviewHitRates = async (brandId, params = {}) => {
    try {
        const { data } = await Http.GET_WITH_ID_PARAM(
            'buyerDashboard',
            params,
            `${brandId}/hit-rates`
        )
        return data
    } catch (error) {
        if (error?.response?.data?.message) {
            toast.error(error.response.data.message)
        } else {
            toast.error('Something went wrong! Please try again.')
        }
        throw error
    }
}

export const fetchOverviewSummary = async (brandId, params = {}) => {
    try {
        const { data } = await Http.GET_WITH_ID_PARAM(
            'buyerDashboard',
            params,
            `${brandId}/summary`
        )
        return data
    } catch (error) {
        if (error?.response?.data?.message) {
            toast.error(error.response.data.message)
        } else {
            toast.error('Something went wrong! Please try again.')
        }
        throw error
    }
}

export const fetchOverviewSuppliers = async (brandId, params = {}) => {
    try {
        const { data } = await Http.GET_WITH_ID_PARAM(
            'buyerDashboard',
            params,
            `${brandId}/suppliers`
        )
        return data
    } catch (error) {
        if (error?.response?.data?.message) {
            toast.error(error.response.data.message)
        } else {
            toast.error('Something went wrong! Please try again.')
        }
        throw error
    }
}
